export class NewsletterContactApiModel {
  firstName?: string;
  lastName?: string;
  email: string;
}
